import { AuditionService } from "../../services/AuditionService";
import {
  SET_LOADING,
  SET_ALL_AUDITION_LIST,
  SET_ALL_AUDITION_LIST_META,
  SET_ACTIVE_AUDITION_LIST,
  SET_ACTIVE_AUDITION_LIST_META,
  SET_PAST_AUDITION_LIST,
  SET_PAST_AUDITION_LIST_META,
  SET_DRAFT_AUDITION_LIST,
  SET_DRAFT_AUDITION_LIST_META,
  SET_CLOSED_AUDITION_LIST,
  SET_CLOSED_AUDITION_LIST_META,
  SET_AUDITION,
  SET_AUDITION_TAB,
  SET_SELECTED_LOCATION,
} from "./types";

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to set loading
 */
export const setLoading = (data) => ({
  type: SET_LOADING,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to set All Audition list
 */
export const setAllAuditionList = (data) => ({
  type: SET_ALL_AUDITION_LIST,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to set All Audition list meta
 */
export const setAllAuditionListMeta = (data) => ({
  type: SET_ALL_AUDITION_LIST_META,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to set Active Audition list
 */
export const setActiveAuditionList = (data) => ({
  type: SET_ACTIVE_AUDITION_LIST,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to set Active Audition list meta
 */
export const setActiveAuditionListMeta = (data) => ({
  type: SET_ACTIVE_AUDITION_LIST_META,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to set Past Audition list
 */
export const setPastAuditionList = (data) => ({
  type: SET_PAST_AUDITION_LIST,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to set Past Audition list meta
 */
export const setPastAuditionListMeta = (data) => ({
  type: SET_PAST_AUDITION_LIST_META,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to set Draft Audition list
 */
export const setDraftAuditionList = (data) => ({
  type: SET_DRAFT_AUDITION_LIST,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to set Draft Audition list meta
 */
export const setDraftAuditionListMeta = (data) => ({
  type: SET_DRAFT_AUDITION_LIST_META,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to set Closed Audition list
 */
export const setClosedAuditionList = (data) => ({
  type: SET_CLOSED_AUDITION_LIST,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to set Closed Audition list meta
 */
export const setClosedAuditionListMeta = (data) => ({
  type: SET_CLOSED_AUDITION_LIST_META,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to set selected Audition data
 */
export const setAudition = (data) => ({
  type: SET_AUDITION,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to set selected Tab
 */
export const setSelectedTab = (data) => ({
  type: SET_AUDITION_TAB,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @description to set location
 */
export const setSelectedLocation = (data) => ({
  type: SET_SELECTED_LOCATION,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to get All Audition list
 */
export const getAllAuditionList =
  (params, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await AuditionService.getAuditionList({ ...params })
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setAllAuditionList(res?.data[0]));
        await dispatch(setAllAuditionListMeta(res?.metadata));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("All audition list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to get Active Audition list
 */
export const getActiveAuditionList =
  (params, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await AuditionService.getAuditionList({ ...params, isActive: true })
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setActiveAuditionList(res?.data[0]));
        await dispatch(setActiveAuditionListMeta(res?.metadata));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Active audition list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to get Past Audition list
 */
export const getPastAuditionList =
  (params, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await AuditionService.getAuditionList({ ...params, isPast: true })
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setPastAuditionList(res?.data[0]));
        await dispatch(setPastAuditionListMeta(res?.metadata));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Past audition list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to get Draft Audition list
 */
export const getDraftAuditionList =
  (params, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await AuditionService.getAuditionList({ ...params, isDraft: true })
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setDraftAuditionList(res?.data[0]));
        await dispatch(setDraftAuditionListMeta(res?.metadata));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Draft audition list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @description to get Closed Audition list
 */
export const getClosedAuditionList =
  (params, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await AuditionService.getAuditionList({ ...params, isClosed: true })
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setClosedAuditionList(res?.data[0]));
        await dispatch(setClosedAuditionListMeta(res?.metadata));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Closed audition list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to delete job
 */
export const deleteAuditions =
  (params, successCallback, errorCallback) => async (dispatch) => {
    // await dispatch(setLoading(true));
    await AuditionService.deleteAudition(params)
      .then(async (res) => {
        console.log("Result: ", res);
        successCallback(res);
      })
      .catch(async (err) => {
        console.log("Error in logout: ", err);
        errorCallback(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
